export default __webpack_public_path__ + "static/DE_Apple_Podcasts_Listen_Badge_RGB-d63a56fda20ba2298235f5ced997583f.svg";